import React, { useEffect, useState, useCallback } from 'react';
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { GetPostMeta } from '../services/apiservice';

const TitleManager = () => {
  const location = useLocation();
  const [metaData, setMetaData] = useState();
  const paramlink = location.pathname.split("/").filter(Boolean).pop();
  const fillPostMetaData = async () => {
    if (paramlink !== undefined && paramlink !== "") {
      try {
        const postMetaList = await GetPostMeta(paramlink);
        const jsonMetaList = JSON.parse(postMetaList);
        setMetaData(jsonMetaList);
      } catch (error) {
        console.error('Error fetching the meta data:', error);
      }
    }
  };

  const getMetaFromData = (metaData) => {
    if (!metaData) return {};
    const titleMeta = metaData?.title;
    const descMeta = metaData?.description;
    const keywordMeta = metaData?.keywords;

    const metaDataDb = {
      title: titleMeta,
      description: descMeta,
      keyword: keywordMeta
    };
    return metaDataDb;
  };

  // Default values if route is not found
  const defaultMeta = {
    title: "Best JSON Validator and JSON Formatter - Data Beautifier",
    description: "Use Data Beautifier to validate, format, and minify JSON, XML, and other data formats with ease.",
    keyword: "json formatter, json beautifier, json validator, online json formatter, json formatter online, json beautify, beautify json, format json, JSON Cleaner, json converter, json format, json online format, format json online"
  };

  // 1. DB meta (if exists)
  const dbMeta = getMetaFromData(metaData);

  // 3. Fallback default meta
  const finalMeta = {
    title: dbMeta.title || defaultMeta.title,
    description: dbMeta.description || defaultMeta.description,
    keyword: dbMeta.keyword || defaultMeta.keyword,
  };

  const { title, description, keyword } = finalMeta;

  const canonicalUrl = window.location.href; // current page URL

  useEffect(() => {
    document.title = title;
    fillPostMetaData();
  }, [paramlink]);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="author" content="Data Beautifier" />
      <meta name="keywords" content={keyword}  />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content="@databeautifier" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="https://databeautifier.com/rectlogo.png" />
      <meta name="twitter:url" content={`https://databeautifier.com${location.pathname}`} />
      <meta name="twitter:creator" content="@databeautifier" />
      <meta property="og:title" content={title} />
      <meta property="og:description"  content={description} />
      <meta property="og:image" content="https://databeautifier.com/rectlogo.png" />
      <meta property="og:url" content={`https://databeautifier.com${location.pathname}`} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Data Beautifier" />
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default TitleManager;

